module.exports = __webpack_public_path__ + "749945526d7d7b71d97af837c41148ed.svg";